import { Stack, Grid, TextField } from "@mui/material";
import MaterialSelect from "../../components/MaterialSelect";
import MaterialTypography from "../../components/MaterialTypography";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import DynamicTable from "../../components/Dynamictabel/Dynamictabel";
import { useEffect, useState } from "react";
import MaterialDatePicker from "../../components/MaterialDatePicker";
import axios from "axios";
import { BASE_URL, fetchData, postData } from "../Utils/Baseurl";
import { useAuth } from "../../context/AuthContext";
import SimpleTable from "../../components/SimpleTable";
import MaterialBox from "../../components/MaterialBox";
import { IconButton } from "@mui/material";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

const TaskFilter = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { currentUser } = useAuth();
  const [types] = useState(false);
  const [project, setProject] = useState([]);
  const [teamMembersData, setTeamMembersData] = useState([]);

  const [filterData, setFilterData] = useState({
    resources: { value: null, label: "All" },
    name: { value: null, label: "All" },
    startDate: "",
    endDate: "",
    actual_date: "",
    status: { value: null, label: "All" },
    search: ""
  });

  const [summary, setSummary] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  const userColumns = [
    { header: "Action", key: "action" },
    { header: "Project Name", key: "project_name" },
    { header: "Milestone", key: "milestone_name" },
    { header: "Module", key: "module_name" },
    { header: "Task Name", key: "task_title" },
    { header: 'Assigned To', key: 'assignee_name' },
    { header: "Status", key: "status" },
    { header: "Start Date", key: "start_date" },
    { header: "End Date", key: "end_date" },
    { header: "Actual Start Date", key: "actual_start_date" },
    { header: "Actual End Date", key: "actual_end_date" },
    { header: "Assigned Hours", key: "assigned_hours" },
    { header: "Actual Hours", key: "actual_hours" },
    { header: "Priority", key: "priority_level" },
    { header: "Task Hold Date", key: "hold_date" },
    { header: "Hold Hours", key: "reason_hours" }
  ];

  const handleClearFilter = () => {
    setFilterData({
      resources: { value: null, label: "All" },
      name: { value: null, label: "All" },
      startDate: "",
      endDate: "",
      actual_date: "",
      status: { value: null, label: "All" },
      search: ""
    });
  };

  const handleStartDateChange = (data) => {
    if (!data || !data[0]) return;
    const date = new Date(data[0]);
    const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    handleChange({ target: { name: 'startDate', value: formattedDate } });
  };

  const handleEndDateChange = (data) => {
    if (!data || !data[0]) return;
    const date = new Date(data[0]);
    const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    handleChange({ target: { name: 'endDate', value: formattedDate } });
  };

  const handleDateChange = (data) => {
    if (!data || !data[0]) return;
    const date = new Date(data[0]);
    const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    handleChange({ target: { name: 'actual_date', value: formattedDate } });
  };

  useEffect(() => {
    fetchTeamMembers();
    fetchProjectData();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
    getTaskList(1);
  }, [types, filterData, sortConfig]);

  const fetchTeamMembers = async () => {
    setIsLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${BASE_URL}api/create_user/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const transformedData = data.data.map((item) => ({
        value: item.id,
        label: `${item.employee_name} -${item.team?.team_name}`,
      }));
      setTeamMembersData([
        {
          value: null,
          label: "All",
        },
        ...transformedData,
      ]);
    } catch (error) {
      console.error("Error fetching team members:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchProjectData = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("user_id", currentUser?.id);
    try {
      const res = await fetchData("/api/project/");
      if (res?.status) {
        setProject([
          {
            project_name: "All",
            id: null,
          },
          ...res?.data,
        ]);
      } else {
        setProject([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getTaskList = async (page = currentPage) => {
    setIsLoading(true);
    if (!types) {
      try {
        const token = sessionStorage.getItem("token");
        const response = await axios.post(
          `${BASE_URL}api/taskfilter/`,
          {
            project_id: filterData?.name?.value,
            employee_id: filterData?.resources?.value,
            start_date: filterData?.startDate,
            end_date: filterData?.endDate,
            actual_date: filterData?.actual_date,
            status: filterData?.status?.value || "",
            search: filterData?.search || "",
          },
          {
            params: {
              page: page,
              ordering: sortConfig.key ? (sortConfig.direction === 'asc' ? sortConfig.key : `-${sortConfig.key}`) : undefined
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = response?.data?.data;
        setData(data);
        setSummary(response?.data?.summary);
        setTotalRows(response?.data?.count || 0);
      } catch (error) {
        console.error(error, "error");
      } finally {
        setIsLoading(false);
      }
    } else {
      try {
        const response = await postData("api/unassignedEmployeesView/", {
          start_date: filterData?.startDate,
          end_date: filterData?.endDate,
        });

        setData(response?.unassigned_employees);
      } catch (error) {
        console.error(error, "error");
      } finally {
        setIsLoading(false);
      }
    }
  };


  // handle onchange function
  const handleChange = (event, selectEvent) => {
    let meetingDatas = { ...filterData };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "name") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          meetingDatas[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          meetingDatas[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "resources") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          meetingDatas[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          meetingDatas[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      meetingDatas[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "endDate":
          if (event.target.value) {
            meetingDatas[event.target.name + "Status"] = "success";
          } else {
            meetingDatas[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
          break;
        case "startDate":
          if (event.target.value) {
            meetingDatas[event.target.name + "Status"] = "success";
          } else {
            meetingDatas[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
          break;
        case "actual_date":
          if (event.target.value) {
            meetingDatas[event.target.name + "Status"] = "success";
          } else {
            meetingDatas[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
          break;

        default:
          break;
      }
      meetingDatas[event.target.name] = event.target.value;
    }

    setFilterData(meetingDatas);
  };
  // Table column data
  const userColumnsNew = [
    { header: "S.No", key: "id" },
    { header: "Emplyoee Name", key: "emplyoee" },
    { header: "Designation", key: "designation" },
  ];
  // Table row data
  const userData = data.map((item, ind) => ({
    id: ind + 1,
    emplyoee: item?.name,
    designation: item?.designation,
  }));

  // console.log(totalAssignedHours, totalActualHours, "FFF");


  return (
    <DashboardLayout>
      <MaterialBox sx={{ padding: 1 }}>
        <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={1}>
          <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: 3 }}>
            <MaterialTypography variant='h5' color='dark' fontWeight='bold'>
              Task Filter
            </MaterialTypography>
            <MaterialTypography variant='caption' color='textSecondary'>
              You can view the portfolio here.
            </MaterialTypography>
          </MaterialBox>
        </Stack>

        <Grid container spacing={2} sx={{ mb: 2, mt: 1 }}>
          {!types && (
            <>
              <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                <Stack spacing={1}>
                  <MaterialTypography variant='caption' color='text' fontWeight='medium'>
                    Resources Name
                  </MaterialTypography>
                  <MaterialSelect
                    size='small'
                    name="resources"
                    placeholder="Select Resource"
                    value={filterData?.resources}
                    onChange={(val) => handleChange(val, { name: 'resources' })}
                    options={teamMembersData || []}
                  />
                </Stack>
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                <Stack spacing={1}>
                  <MaterialTypography variant='caption' color='text' fontWeight='medium'>
                    Project Name
                  </MaterialTypography>
                  <MaterialSelect
                    size='small'
                    name="name"
                    placeholder="Select Project"
                    value={filterData?.name}
                    onChange={(val) => handleChange(val, { name: 'name' })}
                    options={project?.map((item) => ({
                      value: item?.id,
                      label: item?.project_name,
                    }))}
                  />
                </Stack>
              </Grid>
            </>
          )}

          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Stack spacing={1}>
              <MaterialTypography variant='caption' color='text' fontWeight='medium'>
                Start Date
              </MaterialTypography>
              <MaterialDatePicker
                name="startDate"
                type="date"
                value={filterData?.startDate}
                onChange={handleStartDateChange}
                input={{ size: 'small' }}
              />
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Stack spacing={1}>
              <MaterialTypography variant='caption' color='text' fontWeight='medium'>
                End Date
              </MaterialTypography>
              <MaterialDatePicker
                name="endDate"
                type="date"
                value={filterData?.endDate}
                onChange={handleEndDateChange}
                input={{ size: 'small' }}
              />
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Stack spacing={1}>
              <MaterialTypography variant='caption' color='text' fontWeight='medium'>
                Date
              </MaterialTypography>
              <MaterialDatePicker
                name="actual_date"
                type="date"
                value={filterData?.actual_date}
                onChange={handleDateChange}
                input={{ size: 'small' }}
              />
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Stack spacing={1}>
              <MaterialTypography variant='caption' color='text' fontWeight='medium'>
                Status
              </MaterialTypography>
              <MaterialBox sx={{ display: 'flex', gap: 1 }}>
                <MaterialSelect
                  size='small'
                  name="status"
                  placeholder="Select Status"
                  value={filterData?.status}
                  onChange={(val) => handleChange(val, { name: 'status' })}
                  options={[
                    { value: null, label: 'All' },
                    { value: '0', label: 'Not Started' },
                    { value: '1', label: 'In Progress' },
                    { value: '3', label: 'On Hold' },
                    { value: '2', label: 'Completed' },
                    { value: '4', label: 'Aborted' }
                  ]}
                />
                <IconButton
                  onClick={handleClearFilter}
                  sx={{
                    backgroundColor: '#fff1f2',
                    '&:hover': { backgroundColor: '#ffe4e6' },
                    p: 0.8
                  }}
                >
                  <FilterAltOffIcon sx={{ color: "#F63049", fontSize: '1.2rem' }} />
                </IconButton>
              </MaterialBox>
            </Stack>
          </Grid>
        </Grid>

        {summary && (
          <MaterialBox sx={{ mb: 3, mt: 3 }}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                <MaterialBox sx={{
                  p: 2,
                  backgroundColor: '#e3f2fd',
                  borderRadius: '12px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}>
                  <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                    Total Assigned
                  </MaterialTypography>
                  <MaterialTypography variant="h5" color="primary" fontWeight="bold">
                    {summary.total_assigned_hours || 0}
                  </MaterialTypography>
                </MaterialBox>
              </Grid>

              <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                <MaterialBox sx={{
                  p: 2,
                  backgroundColor: '#e8f5e9',
                  borderRadius: '12px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}>
                  <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                    Total Actual
                  </MaterialTypography>
                  <MaterialTypography variant="h5" color="success" fontWeight="bold">
                    {summary.total_actual_hours || 0}
                  </MaterialTypography>
                </MaterialBox>
              </Grid>

              <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                <MaterialBox sx={{
                  p: 2,
                  backgroundColor: '#f3e5f5',
                  borderRadius: '12px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}>
                  <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                    Total Tasks
                  </MaterialTypography>
                  <MaterialTypography variant="h5" color="dark" fontWeight="bold">
                    {summary.total_tasks || 0}
                  </MaterialTypography>
                </MaterialBox>
              </Grid>

              <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                <MaterialBox sx={{
                  p: 2,
                  backgroundColor: '#e8f5e9',
                  borderRadius: '12px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}>
                  <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                    Completed
                  </MaterialTypography>
                  <MaterialTypography variant="h5" color="success" fontWeight="bold">
                    {summary.completed || 0}
                  </MaterialTypography>
                </MaterialBox>
              </Grid>

              <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                <MaterialBox sx={{
                  p: 2,
                  backgroundColor: '#e1f5fe',
                  borderRadius: '12px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}>
                  <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                    In Progress
                  </MaterialTypography>
                  <MaterialTypography variant="h5" color="info" fontWeight="bold">
                    {summary.inprogress || 0}
                  </MaterialTypography>
                </MaterialBox>
              </Grid>

              <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                <MaterialBox sx={{
                  p: 2,
                  backgroundColor: '#fff3e0',
                  borderRadius: '12px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}>
                  <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                    On Hold
                  </MaterialTypography>
                  <MaterialTypography variant="h5" color="warning" fontWeight="bold">
                    {summary.hold || 0}
                  </MaterialTypography>
                </MaterialBox>
              </Grid>

              <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                <MaterialBox sx={{
                  p: 2,
                  backgroundColor: '#ffebee',
                  borderRadius: '12px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}>
                  <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                    Aborted
                  </MaterialTypography>
                  <MaterialTypography variant="h5" color="error" fontWeight="bold">
                    {summary.abort || 0}
                  </MaterialTypography>
                </MaterialBox>
              </Grid>

              <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                <MaterialBox sx={{
                  p: 2,
                  backgroundColor: '#f5f5f5',
                  borderRadius: '12px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}>
                  <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                    Not Started
                  </MaterialTypography>
                  <MaterialTypography variant="h5" color="textSecondary" fontWeight="bold">
                    {summary.not_started || 0}
                  </MaterialTypography>
                </MaterialBox>
              </Grid>

              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Search tasks..."
                  value={filterData.search}
                  onChange={(e) => handleChange(e, { name: 'search' })}
                  name="search"
                  size="small"
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    '& fieldset': { borderRadius: '8px' }
                  }}
                />
              </Grid>
            </Grid>
          </MaterialBox>
        )}

        {!types ? (
          <DynamicTable
            columns={userColumns}
            data={data}
            actionVisibility={{
              showEdit: false,
              showView: false,
              showDelete: false,
            }}
            isLoading={isLoading}
            edit={false}
            deleteAction={false}
            view={false}
            multipleaction={false}
            currentPageProp={currentPage}
            totalRowsProp={totalRows}
            serverSide={true}
            onPageChange={(page) => {
              setCurrentPage(page);
              getTaskList(page);
            }}
            onSort={(config) => setSortConfig(config)}
            sortConfig={sortConfig}
          />
        ) : (
          <SimpleTable
            columns={userColumnsNew}
            data={userData}
            deleteAction={false}
            isLoading={isLoading}
            view={false}
            edit={false}
            download={false}
          />
        )}
      </MaterialBox>
    </DashboardLayout>
  );
};

export default TaskFilter;
